<template>
    <div class="modal-card card">
        <form @submit.prevent="onFormSubmit()">
            <div class="card-header">
                <!-- Title -->
                <h4 class="card-header-title">Delete Certificates</h4>
                <!-- Close -->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="card-body">
                <p>Are you sure you want to delete the following Certificate(s)?</p>
                <ul class="list-group list-group-sm">
                    <li v-for="item in modalData" :key="item.index" class="list-group-item">
                        {{ item.commonName }}
                    </li>
                </ul>
            </div>
            <div class="card-footer text-end">
                <button class="btn btn-danger" :disabled="deleteInProgress">
                    <div v-if="deleteInProgress" class="spinner-border spinner-border-sm" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <div v-else>
                        Delete
                    </div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    data() {
        return {
            error: "",
            deleteInProgress: false
        };
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    name: "DeleteCertificates",
    methods: {
        ...mapActions("aut", {
            deleteCertificate: "deleteCertificate",
        }),
        async onFormSubmit() {
            this.deleteInProgress = true;
            let toastOptions = {
                message: "Certificate(s) deleted successfully.",
                type: "success"
            }
            try {
                for (const record of this.modalData) {
                    await this.deleteCertificate(record.commonName)
                }
            } catch (error) {
                if (error.response.data.error)
                    this.error = error.response.data.error;
                else this.error = error.message;
                toastOptions = {
                    message: error || "Something went wrong while deleteing certificates. Please contact support.",
                    type: "error"
                }
                return;
            } finally {
                this.deleteInProgress = false;
                this.$store.dispatch("addToast", toastOptions);
            }
            this.$store.dispatch("hideModal");
            this.$store.state.aut.deleteCertTrigger = !this.$store.state.aut.deleteCertTrigger;
            this.$store.state.aut.listCertTrigger = !this.$store.state.aut.listCertTrigger
        },
    },
};
</script>

<style></style>